import api from '@/utils/api';
import {
    FETCH_POSTS,
    FETCH_POST,
    CREATE_POST,
    UPDATE_POST,
    REMOVE_POSTS
} from './types';
import { NotificationManager } from 'react-notifications';

const getErrorMessage = (error, fallback) => error.response?.data?.msg || fallback;

export const fetchPosts = filter => dispatch => api.get('/posts', { params: filter })
    .then(res => {
        dispatch({ type: FETCH_POSTS, payload: res.data.data });
        return res.data;
    })
    .catch(error => {
        NotificationManager.error(getErrorMessage(error, 'Không thể tải danh sách bài viết.'));
        throw error;
    });

export const fetchPost = id => dispatch => api.get(`/posts/${id}`)
    .then(res => {
        dispatch({ type: FETCH_POST, payload: res.data.data });
        return res.data.data;
    })
    .catch(error => {
        NotificationManager.error(getErrorMessage(error, 'Không thể tải chi tiết bài viết.'));
        throw error;
    });

export const createPost = data => dispatch => api.post('/posts', data)
    .then(res => {
        dispatch({ type: CREATE_POST, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Thêm bài viết thành công.');
        return res.data.data;
    })
    .catch(error => {
        NotificationManager.error(getErrorMessage(error, 'Không thể thêm bài viết.'));
        throw error;
    });

export const updatePost = (id, data) => dispatch => api.put(`/posts/${id}`, data)
    .then(res => {
        dispatch({ type: UPDATE_POST, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Cập nhật bài viết thành công.');
        return res.data.data;
    })
    .catch(error => {
        NotificationManager.error(getErrorMessage(error, 'Không thể cập nhật bài viết.'));
        throw error;
    });

export const removePosts = ids => dispatch => api.delete('/posts', { data: { ids } })
    .then(res => {
        dispatch({ type: REMOVE_POSTS, payload: ids });
        NotificationManager.success(res.data.msg || 'Xóa bài viết thành công.');
        return res.data.data;
    })
    .catch(error => {
        NotificationManager.error(getErrorMessage(error, 'Không thể xóa bài viết.'));
        throw error;
    });

export const uploadPostImage = file => () => api.post('/upload', { files: [file] })
    .then(res => {
        const imageUrl = res.data?.data?.[0];
        if (res.data?.status !== 'success' || !imageUrl) {
            throw new Error(res.data?.msg || 'Không thể tải ảnh lên.');
        }
        return imageUrl;
    })
    .catch(error => {
        NotificationManager.error(getErrorMessage(error, error.message || 'Không thể tải ảnh lên.'));
        throw error;
    });
